import { Affix, Col, Row } from 'antd';
import {
  Footer,
  FooterProps,
} from '@smartpaddle/biz-bamboo-v2.navigation.footer';
import { StyledFullWidthSpace } from '@Src/components/Onboarding/common/StyledStepComponent';
import React, { useEffect, useState } from 'react';

import PageBanner from '@Src/components/Onboarding/common/PageBanner';
import GstrReports from '@Src/components/Onboarding/DocumentSubmission/GstrReports';
import { useHistory } from 'react-router-dom';
import { StyledOnboardingContainer } from '../Onboarding/StyledComponents';

function SubmitDocument() {
  const [disableSubmit, setDisableSumit] = useState(true);
  const history = useHistory();

  const footerProps: FooterProps = {
    tertiaryButtonName: 'Back',
    primaryButtonName: 'Submit',

    primaryButtonProps: {
      onClick: () => {
        history.goBack();
      },
      disabled: disableSubmit,
    },
    tertiaryButtonProps: {
      onClick: () => {
        history.goBack();
      },
    },
  };

  return (
    <Row justify="center" className="one-bizongo-main-layout-centered-page">
      <Col xs={16} className="h-gap-12">
        <StyledFullWidthSpace direction="vertical">
          <PageBanner
            title="Submit Your Documents"
            subTitle="You are submitting documents to view credit limits you are eligible for."
          />
        </StyledFullWidthSpace>
        <StyledOnboardingContainer>
          <GstrReports setVerificationPending={setDisableSumit} />
        </StyledOnboardingContainer>
        <Affix className="biz-page-primary-container-footer" offsetBottom={0}>
          <Footer {...footerProps} />
          <Row
            className=" bg-white font-weight-600 pt-4 font-size-10 gray-8 v-gap-2"
            justify="end"
          >
            By clicking “Submit”, you agree to{' '}
            <a
              href="https://www.bizongo.com/terms-and-conditions"
              target="_blank"
              rel="noreferrer"
            >
              Terms and conditions
            </a>
          </Row>
        </Affix>
      </Col>
    </Row>
  );
}

export default SubmitDocument;
